<template>
<nav class="sl-footer" v-if="show" aria-label="主要導覽"><van-tabbar v-model="active" :border="false" class="sl-tabbar">
  <van-tabbar-item to="/home" :class="active===0?'bc-router':'bc-noroute'"><span>{{ $t('foorter.index') }}</span><template #icon><sl-icon name="home" /></template></van-tabbar-item>
  <van-tabbar-item to="/history" :class="active===1?'bc-router':'bc-noroute'"><span>{{ $t('foorter.subscribe') }}</span><template #icon><sl-icon name="grid" /></template></van-tabbar-item>
  <van-tabbar-item :to="`/Lottery?key=${gameitem[0]?.key || ''}&id=${gameitem[0]?.id || ''}`" :class="active===2?'bc-router':'bc-noroute'"><span>{{ $t('foorter.video') }}</span><template #icon><sl-icon name="game" /></template></van-tabbar-item>
  <van-tabbar-item to="/mine" :class="active===3?'bc-router':'bc-noroute'"><span>{{ $t('foorter.my') }}</span><template #icon><sl-icon name="user" /></template></van-tabbar-item>
</van-tabbar></nav>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      // 接口返回为数组，初始为空数组
      gameitem: [],
    };
  },
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // 初始化匹配当前页面高亮
    this.setActiveByRoute(this.$route.name);
    // 初始化请求接口，拿到 key id
    this.getGameItem();
    if (this.is_show) {
      this.show = true;
    }
  },
  watch: {
    // 路由切换自动切换tab高亮
    $route(to) {
      this.setActiveByRoute(to.name);
    },
  },
  methods: {
    // 获取彩票默认配置参数
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = res.data || [];
      });
    },
    // 根据路由name切换tab
    setActiveByRoute(name) {
      switch (name) {
        case "home":
        case "choose":
          this.active = 0;
          this.show = true;
          break;
        case "history":
          this.active = 1;
          this.show = true;
          break;
        case "Lottery":
          this.active = 2;
          this.show = true;
          break;
        case "mine":
          this.active = 3;
          this.show = true;
          break;
        default:
          this.show = false;
      }
    },
  },
};
</script>
